let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6m9MP")).then(() => parcelRequire('2mygo'));